module.exports = __webpack_public_path__ + "static/media/banner.343b97db.svg";